import HTTPClient from './HTTPClient';

export const checkForHtmlContent = async url => {
    const response = await HTTPClient().get(url);
    return response.headers.get('content-type').includes('text/html');
};
